import { render, staticRenderFns } from "./DashsoardCard.vue?vue&type=template&id=563c71d5&scoped=true&"
import script from "./DashsoardCard.vue?vue&type=script&lang=js&"
export * from "./DashsoardCard.vue?vue&type=script&lang=js&"
import style0 from "./DashsoardCard.vue?vue&type=style&index=0&id=563c71d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c71d5",
  null
  
)

export default component.exports